var carData = {
	//车易拍圆盘页面初始化
	GetAuctionDetail(applyId,token) {
		return $.ajax({
			dataType: "json",
			type: "post",
			url: `${process.env.DSC_BASE_URL}/applyAuctionOrderApi/queryAuctionCYPConstantInfo.json?applyId=${applyId}&_security_token=${token}`
		})
	},
    //弹幕(浏览次数、关注次数)
    GetBarrage(applyId,token) {
        return $.ajax({
            dataType: "json",
            type: "post",
            url: `${process.env.DSC_BASE_URL}/applyAuctionOrderApi/queryBarrageV3?applyId=${applyId}&_security_token=${token}`
        })
    },
    //拍卖是否真的结束
    GetEndTime(aucId) {
        return $.ajax({
            dataType: "json",
            type: "get",
            url: `${process.env.CYP_BASE_URL}/api/Auction/GetCarEndTime?aucId=${aucId}`
        })
    },
    //出价记录
    GetBidList(aucId,token) {
        return $.ajax({
            dataType: "json",
            type: "get",
            headers:{
                onlineid: token
            },
            url: `${process.env.CYP_BASE_URL}/api/Auction/GetBidsListByAucId?aucId=${aucId}&top=10000&requestType=1`
        })
    },
    //同步token
    SyncToken(token) {
        return $.ajax({
            dataType: "json",
            type: "post",
            url: `${process.env.DSC_BASE_URL}/publicApi/syncToken.json?token=${token}`
        })
    },
    //根据申请单id查询所有车商
    GetAllDealer(applyId,token) {
        return $.ajax({
            dataType: "json",
            type: "get",
            url: `${process.env.DSC_BASE_URL}/auctionDealerAction/getAllDealerByApplyId.json?applyId=${applyId}&_security_token=${token}`
        })
    },
    GetAuthPower(token) {
        return $.ajax({
            dataType: "jsonp",
            type: "get",
            url: `${process.env.DSC_PAR_URL}/httpApi/getAuthz.jsonp?_security_token=${token}`,
        })
    },
	//确认流拍
	ConfirmUnsold(applyId,token) {
		return $.ajax({
			dataType: "json",
			type: "post",
			url: `${process.env.DSC_BASE_URL}/applyAuctionOrderApi/confirmUnsold.json?applyId=${applyId}&_security_token=${token}`
		})
	},
	//二次上拍
	SecondaryShot(applyId,isDisplay,token) {
		return $.ajax({
			dataType: "json",
			type: "post",
			url: `${process.env.DSC_BASE_URL}/applyAuctionOrderApi/appplydetail.json?applyId=${applyId}&isDisplayPrice=${isDisplay}&_security_token=${token}`
		})
	},
	//报价单初始化
	GetQuotationDetail(reportCode) {
		return $.ajax({
			dataType: "json",
			type: "get",
			url: `${process.env.CYP_BASE_URL}/api/CarData/CompleteReport?reportCode=${reportCode}`
		})
	},
	//报价单价格有效期
	GetPriceValidity(carId,isLookPrice, assessmentOrderId) {
		return $.ajax({
			dataType: "json",
			type: "get",
			url: `${process.env.DSC_BASE_URL}/car/quotationManagerAction/getShareExpectContractPrice.json?carId=${carId}&isLookPrice=${isLookPrice}&assessmentOrderId=${assessmentOrderId}`
		})
	},
    /*
    * 获取大域自动流拍时长接口
    * */
    GetAutoLiuPaiTime(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.CYP_BASE_URL}/goodsService/Market/GetAutoLiuPaiTime`
        })
    },
    /*
    * 获取城市编码
    * */
    getStandardCityCodeBySCCityCode(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_BASE_URL}/publicApi/getStandardCityCodeBySCCityCode.json`
        })
    },
    /*
    * 暗拍 获取状态的接口
    * */
    GetAuctionInfoByAucIds(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.CYP_BASE_URL}/api/Auction/GetAuctionInfoByAucIds`
        })
    },
    /*
    * 暗拍获取shopMemberCode 建立长链接
    * */
    syncUser(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_BASE_URL}/publicApi/syncUser.json`
        })
    },
	/*
	* 高级拍卖详情初始化页面的接口
	* */
    FindAuctionDetail(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_BASE_URL}/room/roomManagerAction/findAuctionDetail.json`
        })
    },
    /*
    * 高级拍卖出价记录接口
    * */
    FindPriceList(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_BASE_URL}/room/roomManagerAction/findPriceList.json`
        })
    },
    /*
    * 高级拍卖出价记录图标接口
    * */
   getTenantImgByCode(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_BASE_URL}/wholesaleAPI/getTenantImgByCode.json`
        })
    },

    /*
    * 平台化查询拍卖车辆信息
    * */
    findCarDetail(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_BASE_URL}/auction/auctionManagerApi/findCarDetail.json`
        })
    },

     /*
    * 参考新车价
    * */
   marketPrice(data, token, partnerId) {
    return $.ajax({
        dataType: "json",
        type: "post",
        headers: {
            "onlineId": token,
            "partnerId": partnerId
        },
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/valuateCarPrice/marketPrice`
    });
},
/*
* 零售价未来走势
* */
futureRetailTrendPrice(data, token, partnerId) {
    return $.ajax({
        dataType: "json",
        type: "post",
        headers: {
            "onlineId": token,
            "partnerId": partnerId
        },
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/valuateCarPrice/futureRetailTrendPrice`
    });
},
/*
* 新车价格走势
* */
newCarTrendPrice(data, token, partnerId) {
    return $.ajax({
        dataType: "json",
        type: "post",
        headers: {
            "onlineId": token,
            "partnerId": partnerId
        },
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/valuateCarPrice/newCarTrendPrice`
    });
},
/*
* 库存走势
* */
carStoreTrend(data, token, partnerId) {
    return $.ajax({
        dataType: "json",
        type: "post",
        headers: {
            "onlineId": token,
            "partnerId": partnerId
        },
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/valuateCarStore/carStoreTrend`
    });
},
/*
* 库存周转周期
* */
carTurnoverCycle(data, token, partnerId) {
    return $.ajax({
        dataType: "json",
        type: "post",
        headers: {
            "onlineId": token,
            "partnerId": partnerId
        },
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/valuateCarStore/carTurnoverCycle`
    });
},
/*
*拍卖行情，零售行情
* */
getCarInfo(data, token, partnerId) {
    return $.ajax({
        dataType: "json",
        type: "post",
        headers: {
            "onlineId": token,
            "partnerId": partnerId
        },
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/valuateCarPrice/carPriceMarket`,
    });
},
/*
 * 车况价格信息
 */
// carConditionRequest(data, token, partnerId) {
//     return $.ajax({
//         dataType: "json",
//         type: "post",
//         headers: {
//             "onlineId": token,
//             "partnerId": partnerId
//         },
//         contentType: "application/json;charset=utf-8",
//         data: JSON.stringify(data),
//         url: `${process.env.NPI_BASE_URL}/cheyipai/evaluation/evaluationAppApi/freeEvaluation.json`,
//     });
// },
/*
* 车系模糊搜索的接口
* */
querySuggest(data) {
    return $.ajax({
        dataType: "json",
        type: "post",
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/carModel/querySuggest`,
    });
},
/*
* 获取所有城市的接口
* */
getAllCity(data) {
    return $.ajax({
        dataType: "json",
        type: "post",
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/area/getAllCity`,
    });
},
/*
* 根据定位的城市获取对应城市code的接口
* */
matchCity(data) {
    return $.ajax({
        dataType: "json",
        type: "post",
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/area/matchCity`,
    });
},

/*
 * 根绝车系获取变速箱，排油量的过滤选项
 */
getFilterTags(data) {
    return $.ajax({
        dataType: "json",
        type: "post",
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/carModel/modelConfig`,
    });
},
/*
 * 获取上传图片的服务器地址
 */
getImgUrl(data) {
    return $.ajax({
        dataType: "json",
        type: "post",
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/image/upload`,
    });
},
/*
 * 根据上传图片的服务器地址，获取VIN码
 */
getVinCodeByUrl(data) {
    return $.ajax({
        dataType: "json",
        type: "post",
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/image/ocr`,
    });
},
/*
 * 根据VIN码，获取车型
 */
getCarModelByVin(data) {
    return $.ajax({
        dataType: "json",
        type: "post",
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(data),
        url: `${process.env.CYP_BASE_URL}/carModel/vinParseConfig`,
    });
},
};

export default carData;



// WEBPACK FOOTER //
// ./src/assets/js/Auction.js